var digistorm = {

    init: function () {

        // load calendars
        this.calendars();
        this.tags();
    },

    calendars: function () {
        var _self = this;
        const customCheckbox = $('body').data('custom-checkbox') == 1;
        function getParameterByName(name, url) {
            var values = []
            if (!url) url = location.href
        
            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]")
        
            var pattern = name + '=([^&#]+)'
            var o_reg = new RegExp(pattern,'ig')
            while (true){
                var matches = o_reg.exec(url)
                if (matches && matches[1]){
                    values.push(matches[1])
                } else {
                    break
                }
            }
        
            if (!values.length){
                return null
            } else {
                return values
            }
        }
        
        function setParamaterByName(name, value, url) {
            if (!url) url = location.href
        
            // remove all instances of param
            var params = new RegExp(name + '(\\[\\]|)=[^&#]*&*', 'g')
            var newUrl = url.replace(params, '')
        
            // strip ending ampersand
            newUrl = newUrl.replace(/&$/, '')
        
            // append ? if it doesn't exist
            if (url.indexOf('?') == -1) {
                newUrl += '?'
            }
        
            // append each item if array
            if (Array.isArray(value)) {
                value.forEach(function(item) {
                    newUrl += '&' + name + '[]=' + item
                })
            } else {
                newUrl += '&' + name + '=' + value
            }
        
            return newUrl
        }
        
        
        var tagIds = getParameterByName('tag_ids[]', false)
        var tagParam = ''
        if (tagIds) {
            tagIds.forEach(function(tag) {
                tagParam += '&tag_ids[]=' + tag
            })
        }
        var startDate = getParameterByName('start_date', false)
        startDate = startDate ? startDate[0] : null
        
        if ( $('.calendar-tag-checkboxes').length ) {
            console.log('Calendar tag checkboxes found, loading tags...');
            var $checkboxes = $('.calendar-tag-checkboxes')
            var $listFilters = $('.expand-filters .list-filters')
            var filterCount = 0;
            $.ajax({
                url: "/api/tags.php"
            }).done(function (response){
        
                response.sort(function(a, b){
                    if(a.name < b.name) { return -1; }
                    if(a.name > b.name) { return 1; }
                    return 0;
                })
        
                response.forEach(function (e) {
                    console.log(e.tag_category_id);
                    if (e.tag_category_id == 780 || customCheckbox) {
                        var $label    = $('<label>')
                        $label.css('background-color', e.color);
                        $label.css('color', '#fff');
                        var $checkbox = $('<input>')
                        var $legend   = $('<span>').addClass('legend')
        
                        // set checkbox attributes
                        $checkbox.attr('type', 'checkbox')
                        $checkbox.attr('name', 'calendar-tag-checkboxes')
                        $checkbox.attr('value', e.id)
        
                        // on checkbox change, adjust select all checkbox
                        $checkbox.change(function (e) {
                            if ($(e.target).is(':checked')) {
                                boxes   = $checkboxes.find('input:not(.all-tags-checkbox)')
                                checked = $checkboxes.find('input:not(.all-tags-checkbox):checked')
                                if (boxes.length == checked.length) {
                                    $('.all-tags-checkbox').prop('checked', true)
                                }
                            } else {
                                $('.all-tags-checkbox').prop('checked', false)
                            }
                        })
        
                        // if it in the request, mark it as checked
                        if (tagIds && tagIds.indexOf(e.id + '') != -1) {
                            $checkbox.prop('checked', true)
                            filterCount++;
                        }
        
                        // set color of legend
                        if (e.color)
                            $legend.css('background-color', e.color)
        
                        // append everything
                        $label.append($checkbox)
                        $label.append(escapeHtml(e.name))
                        // $label.append($legend)
                        $checkboxes.append($label)
                    }
                })
        
                // check select all if all filters were selected
                if (filterCount == 0 || filterCount == response.length){
                    $listFilters.text('All')
                    if (filterCount == response.length) {
                        $('.all-tags-checkbox').prop('checked', true)
                    }
                } else {
                    $listFilters.text(filterCount)
                }
            })
        
            $('.expand-filters').click(function() {
                $(this).closest('.tag-filter-wrapper').toggleClass('active')
            });
        
            $('.all-tags-checkbox').change(function (e) {
                if ($(e.target).is(':checked')) {
                    $('.calendar-tag-checkboxes input').prop('checked', true)
                } else {
                    $('.calendar-tag-checkboxes input').prop('checked', false)
                }
            })
            // 2. When custom‑checkbox mode is ON ...
            if (customCheckbox) {
                console.log('Custom checkbox mode is ON');
                $(document).on('change', '.calendar-tag-checkboxes input[type="checkbox"]', function () {
                    const isAll = $(this).hasClass('all-tags-checkbox');
                
                    if (isAll) {
                        const checked = $(this).is(':checked');
                        $('.calendar-tag-checkboxes input[type="checkbox"]').not('.all-tags-checkbox').prop('checked', checked);
                    } else {
                        const all = $('.calendar-tag-checkboxes input[type="checkbox"]').not('.all-tags-checkbox');
                        const checked = $('.calendar-tag-checkboxes input[type="checkbox"]:checked').not('.all-tags-checkbox');
                        $('.all-tags-checkbox').prop('checked', all.length === checked.length);
                    }
                
                    // Collect selected tag IDs
                    const values = $('.calendar-tag-checkboxes input:checked')
                        .not('.all-tags-checkbox')
                        .map(function () {
                            return $(this).val();
                        })
                        .get();
                
                    // Redirect with updated query string
                    window.location.href = setParamaterByName('tag_ids', values);
                });
            
            } else {
                $('.filter-tags-button').click(function(e) {
                    var values   = $('.calendar-tag-checkboxes input:checked').map(function() {
                        return $(this).val()
                    }).get()
                    location.href = setParamaterByName('tag_ids', values)
                });
            }  
        }

        $('#calendar-category-select').change(function() {
            var value = $(this).val();
            document.location = '?category=' + value;
        });

        console.log(getParameterByName('category'));

        $('[data-calendars]').each(function() {
            var calendarUrl = $(this).attr('data-calendar-url');
            var calendarTimezone = $(this).attr('data-calendar-timezone');
            var monthHeader = $(this).attr('data-calendar-month') === '1';
            var customIntegration = $(this).attr('data-custom-calender') === '1';
            var category = getParameterByName('category');
            var tagIds = getParameterByName('tag_ids[]', false)

            $('.calendar-desktop').fullCalendar({
                events: function (start,end,timezone,callback) {
                    if ((customIntegration || tagIds && tagIds.length > 0) || (customCheckbox && tagIds && tagIds.length > 0)) {
                        var url = calendarUrl + "?start=" + start.unix() + "&end=" + end.unix() + tagParam;
                    }else if (category && category.length > 0) {
                        var url = calendarUrl + "?start=" + start.unix() + "&end=" + end.unix() + '&tag_ids[]=' + getParameterByName('category') + '&exclude_untagged=true'
                    }else{
                        var url = calendarUrl + "?start=" + start.unix() + "&end=" + end.unix()
                    }
                    $.ajax({url: url}).done(function (response){callback(response)});
                },
                eventDataTransform: function (e) {
                    var start = moment.tz(parseInt(e.start_time) * 1000, calendarTimezone);
                    e.start = start.format();
                
                    if (e.all_day || e.allDay) {
                        e.allDay = true;
                    }
                    if (e.end_time != null) {
                        var end = moment.tz(parseInt(e.end_time) * 1000, calendarTimezone);
                        if (start.format('HH:mm') == '00:00' && end.format('HH:mm') == '23:59') {
                            e.allDay = true;
                        }
                        if (e.allDay) {
                            end.add(1, 'days')
                        }
                        e.end = end.format();
                    }
                    if (e.all_day || e.allDay) {
                        e.allDay = true;
                    }
                    
                    if (e.tags) {
                        e.tags.forEach(function(tag){
                            e.color = tag.color;
                        })
                    }
                
                    // Decode the title to handle HTML entities like &#39;
                    e.title = $('<textarea>').html(e.title).text();
                
                    return e;
                },
                editable: false,
                timeFormat: 'h:mm A',
                ...(monthHeader && {
                    header: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'month,agendaWeek,agendaDay'
                    }
                }),
                aspectRatio: '1.8',
                timezone: calendarTimezone,
                eventClick: function (event, jsEvent, view) {

                    var $target = $(jsEvent.target)
                    var $event = $target.closest('.fc-event-container');
                    var $modal = $event.find('.cal-modal');

                    if (!$target.closest('.cal-modal').length) { // if not clicking the modal
                        if (!$modal.length) { // add the modal if it doesn't exist

                            $modal = _self.createEventModal(event);
                            $event.append($modal);

                            setTimeout(function () {
                                $modal.addClass('active')
                            }, 100);
                        } else {
                            $modal.addClass('active');
                        }
                    }
                }
            });

            var mobilecalendarUrl = '';
            if ((customIntegration) || (customCheckbox && tagIds && tagIds.length > 0)) {
                var mobilecalendarUrl = calendarUrl + tagParam;
            }else if (category && category.length > 0) {
                    mobilecalendarUrl += calendarUrl + '?tag_ids[]=' + tagIds + '&exclude_untagged=true';
            }else{
                mobilecalendarUrl += calendarUrl;
            }
            $('.calendar-mobile').digistormMobileCalendar({
                url: mobilecalendarUrl,
                timezone: calendarTimezone,
                eventDataTransform: function(event) {
                    event.start = event.start_time;
                    event.end = event.end_time;
                    return event;
                }
            });
        })
    },

    tags: function () {

        function getParameterByName(name, url) {
            var values = []
            if (!url) url = location.href

            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]")

            var pattern = name + '=([^&#]+)'
            var o_reg = new RegExp(pattern,'ig')
            while (true){
                var matches = o_reg.exec(url)
                if (matches && matches[1]){
                    values.push(matches[1])
                } else {
                    break
                }
            }

            if (!values.length){
                return null
            } else {
                return values
            }
        }

        $.ajax({
	    	url: "/api/tagCategories.php",
	    	dataType: "json",
	    	type: "GET",
	    	success: function(response) {
	    		$.each(response, function(index, tag_group) {

	    			$('#calendar-category-select').append($("<option>").attr('value', tag_group.id).text(tag_group.name));

	    		});

	    		var tag_id = getParameterByName('category');
    		 	tag_id ? $('#calendar-category-select').val(tag_id) : "";
    		 	if (tag_id) {
    		 		var tag_name = $('.calendar-category-select').find('option[value="'+tag_id+'"]').text();
    		 		$('.tag-name').text(tag_name + ' Calendar');
    		 	}


	    	},
	    	error: function(err) {
	    		console.log(err);
	    	}

        });
    },

    // create modal from reach event
    createEventModal: function (event) {
        $modal = $('<div class="cal-modal"></div>');
        var $holder = $('<div class="content-holder"></div>')
        var $content = $('<div class="content"></div>');

        $content.append('<h2>' + escapeHtml(event.title) + '</h2>');

        var mStart = moment.tz(parseInt(event.start_time) * 1000, event.timezone);
        var mEnd = moment.tz(parseInt(event.end_time) * 1000, event.timezone);
        if (mStart.isSame(mEnd,'day')) {
            if (event.allDay) {
                $content.append('<small>'+mStart.format('D MMMM')+' (All Day)</small>');
            } else {
                if(mStart.format('h:mma') == mEnd.format('h:mma')){
                    $content.append('<small>'+mStart.format('D MMMM')+' (All Day)</small>');
                }else{
                    $content.append('<small>'+mStart.format('D MMMM')+' (' + mStart.format('h:mma') + ' - ' + mEnd.format('h:mma') + ')</small>');
                }
            }
        } else{
            $content.append('<small>' + mStart.format('D MMM') + ' - ' + mEnd.format('D MMM') + '</small>');
        }
        $content.append('<p>' + escapeHtml(event.body) + '</p>');

        if(event.location && event.location.length > 0) {
            $content.append('<p>' +'<i class="fa fa-map-marker"></i> ' + escapeHtml(event.location) + '</p>');
        }

        console.log(event.attachments);
        console.log(event.attachments.length);
        if (event.attachments && event.attachments.length) {
            $.each(event.attachments, function (i, attachment) {
                console.log(attachment.type);
                switch (attachment.type) {
                    case 'address':
                        $content.append('<div class="attachment attachment-address"><i class="fa fa-map-marker"></i> ' + escapeHtml(String(attachment.address)).replace(/\n/g, '<br>') + '</div>');
                        break;
                    case 'contact':
                        var contact_details = [];
                        if (attachment.contact_name) {
                            contact_details.push(escapeHtml(attachment.contact_name));
                        }
                        if (attachment.contact_phone) {
                            contact_details.push($('<a>').attr('href', 'tel:' + attachment.contact_phone ).text(attachment.contact_phone ).prop('outerHTML'));
                        }
                        if (attachment.contact_email) {
                            contact_details.push($('<a>').attr('href', 'mailto:' + attachment.contact_email ).text(attachment.contact_email ).prop('outerHTML'));
                        }
                        $content.append('<div class="attachment attachment-contact"><i class="fa fa-phone"></i> ' + contact_details.join('<br>') + '</div>');
                        break;
                    case 'link':
                        $content.append('<div class="attachment attachment-link"><i class="fa fa-link"></i> ' + $('<a target="blank">').attr('href', attachment.url).text(attachment.url).prop('outerHTML')  + '</div>');
                        break;
                    case 'file':
                        $content.append('<div class="attachment attachment-file"><i class="fa fa-file"></i> ' + $('<a target="blank">').attr('href', attachment.url).text(attachment.file_name).prop('outerHTML') + '</a></div>');
                        break;
                }
            });
        }

        $modal.click(function (event) {
            if ($(event.target).hasClass("cal-modal") || $(event.target).hasClass("close") || $(event.target).hasClass("content-holder")) {
                $(this).removeClass('active');
            }
        });

        $holder.append('<div class="close"></div>');
        $holder.append($content);
        $modal.append($holder);

        return $modal;
    },

}

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

// Yo!
$(document).ready(function () {
    digistorm.init();
});
